export const locale = {
    lang: 'es',
    data: {
        ORDER_DETAIL_MODAL_RATING: {
            TITLE: 'Evaluación del pedido',
            RATING_AVERAGE: 'Media de la evaluación',
            DESCRIPTION: 'Descripción',
        },
    },
};
